import { useEffect } from 'react';

function GoogleSocialLogin() {
  
  useEffect(() => {
    const params = new URLSearchParams({
      client_id: '129492706883-ut7qhu4ln1h4nb41m25v7rndh36tilah.apps.googleusercontent.com', // will change to environment variable
      redirect_uri: 'https://accounts.salla.com/auth/social-callback/google', // will change to environment variable
      response_type: 'code',
      scope: 'openid email profile',
      access_type: 'offline',
      prompt: 'consent',
    });

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  }, []);

  return (
    <div
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        background: '#ffffff',
        color: '#333',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderTop: '4px solid #4285f4',
            borderRadius: '50%',
            width: 50,
            height: 50,
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px',
          }}
        />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default GoogleSocialLogin;
